import { DimensionValue, View } from 'react-native';
import { Circle, Svg } from 'react-native-svg';
import { TIllustrationProps } from '@/common/components/Illustrations/types';

export const IconLoader = ({
  width = 16,
  height = 16,
  color,
  className,
}: TIllustrationProps & {
  width?: DimensionValue;
  height?: DimensionValue;
}) => (
  <View className={className}>
    <View className="animate-spin" style={{ width, height }}>
      <Svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <Circle
          cx="50"
          cy="50"
          fill="none"
          strokeWidth="12"
          r="40"
          strokeDasharray="188 71"
          stroke="currentColor"
          color={color}
        />
      </Svg>
    </View>
  </View>
);
